<template>
  <div class="fixed-banner" :style=" isSushi && 'position: relative'" >
    <drawer :isActive="showDrawer" @closed="showDrawer = false" :isSushi="isSushi"></drawer>
    <div
        v-if="getLogo"
        :class="isSushi ? 'center-logo-sushi ' : 'center-logo'"
        :style="!isSushi && logoContainerStyles"
    >
      <img
          :src="getLogo"
          class="logo "
          alt="logo"

      />
    </div>
    <div
        v-if="showLoginButton || getLogo"
        class="container-fluid mobile-banner"
        :style="logoBackgroundStyles"
    >
      <div class="row">
        <div class="col-7 shop-title" v-if="showLoginButton">
          <router-link to="/" class="text-white">
            <span @click.prevent="hClick" class="material-icons md-36">menu</span>
          </router-link>
        </div>
        <div class="col-5 cart" v-if="showCart">
          <span class="cart">
            <router-link
                :to="{
                name: 'shoppingcartmobile',
                params: {
                  storeid: currentstore,
                  storename: $route.params.storename,
                },
              }"
            >
              <span class="cart-cost">{{ cartValue | formatMoney(currencySign) }}</span>
              <span class="material-icons md-36">shopping_cart</span>
            </router-link>
          </span>
        </div>
      </div>
    </div>

    <div class="container-fluid category-naviagtion intro" :style="getStyle()" v-if="!isSushi" >
      <div class="row">
        <ul class="store-menu-mobile">
          <li class>
            <a :style="mobileStyles.navText" href="#">{{ $t("message.orderOnline") }}</a>
          </li>
        </ul>
      </div>
    </div>

    <!--    sushihub banner-->
    <div v-if="isSushi">

      <sushi-store-banner-mobile  :store="currentstore"/>
    </div>

    <!-- /banner -->

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Drawer from "../shared/drawer";
import {
  IsStoreOpenAtTime,
  getCurrentDate
} from "./../../api/helpers/datetimeHelper.js";
import { DetectBrand } from "../../mixins/brandDetector";
import SushiStoreBannerMobile from "@/components/sushiHub/mobile/sushiStoreBannerMobile";

export default {
  name: "IntroHeaderMobile",
  components: {
    SushiStoreBannerMobile,
    Drawer
  },
  data() {
    return {
      showDrawer: false,
    };
  },
  computed: {
    ...mapGetters([
      "cartValue",
      "currentstore",
      "mobileStyles",
      "currentStoreDoc",
      "hqDoc",
      "currencySign",
    ]),
    showLoginButton() {
      return this.hqDoc &&
          this.hqDoc.ViewComponentConfigs &&
          this.hqDoc.ViewComponentConfigs.LogIn === true &&
          DetectBrand.methods.isBranded() === true;
    },
    showCart() {
      var storeOpen = false;
      if (this.currentStoreDoc) {
        var now = getCurrentDate(this.currentStoreDoc.TimezoneIanaFormat);
        storeOpen = IsStoreOpenAtTime(
            this.currentStoreDoc.BlackoutDates,
            this.currentStoreDoc.OperatingHours,
            this.currentStoreDoc.IsInOperation,
            now
        );
      }
      if (
          this.$route.name &&
          this.$route.name.toLowerCase().indexOf("mainpage") < 0 &&
          this.$route.name.toLowerCase().indexOf("notfoundpage") < 0 &&
          storeOpen
      )
        return true;
      return false;
    },
    getLogo() {
      if(this.hqDoc && this.hqDoc.IsSushiHub){
        return require("../../assets/images/sushiHub/sushiHubLogo.svg")
      }
      return this.hqDoc ? this.hqDoc.Logo : null;
    },
    logoContainerStyles() {
      return this.getLogo ? 'min-height: 100px' : 'max-height: 0';
    },
    logoBackgroundStyles() {
      const amendment = (this.hqDoc && !this.hqDoc.IsSushiHub) && this.getLogo ? {minHeight: '100px'} : {};
      const sushiBackground = {backgroundColor : '#212121', height : 10}
      if( this.hqDoc && this.hqDoc.IsSushiHub){
        return {
          ...amendment,
          ...sushiBackground
        };
      }
      return {
        ...this.mobileStyles.TitleBar,
        ...amendment,
      };
    },

    isSushi(){
      return this.hqDoc && this.hqDoc.IsSushiHub
    }
  },
  methods: {
    hClick() {
      this.showDrawer = !this.showDrawer;
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryBackgroundColour);
      return styles;
    },
  }
};
</script>
